import React, { PureComponent, ReactNode } from "react";
import styled from "styled-components";

import theme, { media } from "../../../../../../../theme";

const Section = styled.article`
  display: flex;
  flex-direction: column;
  margin-top: ${theme.margins.marginLarge};

  ${media.laptop} {
    margin-bottom: ${theme.margins.marginLarge};
  }
`;

const Title = styled.h4`
  font-family: ${theme.fonts.title};
  font-size: 20px;
  letter-spacing: 0;
  text-align: center;
  margin: 0;

  ${media.laptop} {
    font-family: ${theme.fonts.regular};
    font-size: ${theme.fontSizes.regular};
    color: ${theme.colors.darkGold};
    text-align: left;
    text-transform: uppercase;
    letter-spacing: 1px;
  }
`;

interface IProps {
  children?: ReactNode;
  className?: string;
  title?: string;
}

export default class SectionFooter extends PureComponent<IProps> {
  public render(): ReactNode {
    const { children, title, className } = this.props;

    return (
      <Section className={className}>
        {title && <Title>{title}</Title>}
        {children}
      </Section>
    );
  }
}
